module.exports = __webpack_public_path__ + "img/united-states-of-america.feed37dd.png";